import { Controller as BaseController } from 'stimulus'

export class Controller extends BaseController {
  static targets = ['label'];

  static values = {
    expandLabel: String,
    collapseLabel: String
  };

  expanded = false;

  toggle() {
    this.expanded = !this.expanded
    this.element.setAttribute('aria-expanded', this.expanded)
    this.labelTarget.innerHTML = this.expanded ? this.collapseLabelValue : this.expandLabelValue
  }
}
